import React from 'react';

interface TeamIconProps {
  className?: string;
}

function TeamIcon({ className }: TeamIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
      className={className}
    >
      <g id="Icon/Users">
        <path
          id="Icon"
          fill="currentColor"
          fillRule="evenodd"
          d="M9 4.333a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0m11.031-4.118a1 1 0 0 1 1.217-.72 5 5 0 0 1 0 9.687 1 1 0 0 1-.496-1.938 3 3 0 0 0 0-5.812 1 1 0 0 1-.72-1.217M1.464 15.798A5 5 0 0 1 5 14.333h8a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 1.464-3.535m17.568-.585a1 1 0 0 1 1.218-.718A5 5 0 0 1 24 19.332v2.001a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.25-2.902 1 1 0 0 1-.718-1.218"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
}

export default TeamIcon;
